// Archivo limpiado: redundancias eliminadas y uso real mantenido
import * as React from 'react';
import { connect } from 'react-redux';
import {
    setFiltroPublicacion,
    fetchPublicaciones, // NO SE ESTA USANDO fecthPublicaciones
    fetchVariaciones,
    fetchMarcas,
    fetchCategorias
} from '../../../actions/publicacionesActions';
import { fetchExportarPublicacionesApi } from '../../../api/axios';
import { fetchSellers } from '../../../actions/sellersActions';
import { fetchTiposPublicacionAdm } from '../../../actions/tiposPublicacionActions';
import PublicacionesFilter from '../../Publicaciones/Components/PublicacionesFilter';
import BigSpinner from "../../General/BigSpinner";
import MiniSpinner from "../../General/MiniSpinner";
import { toast } from '../../../utilities/appToast';
import { normalizeErrorPayload } from '../../../utilities/apiErrors';
import PropTypes from 'prop-types';
import '../Exportables.css';

class ExportarPublicaciones extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterOptions: { idSeller: null },
            datosExcelFormateados: null,
            listaTipoPublicacionCargada: false,
            hideSpinner: true,
            cantidadPublicaciones: 0,
            excelBase64: null,
            loadingExport: false,
        };
    }

    componentDidMount() {
        this.props.publicaciones.cantidadTotal = 0;
        this.cargarTipoPublicacionLista();
        this.props.fetchVariaciones();
        this.onFetchFilterOptions("");
    }

    componentWillUnmount() {
        this.props.setFiltroPublicacion({});
    }

    onFetchFilterOptions = (descripcion) => {
        this.props.fetchCategorias(descripcion);
        this.props.fetchMarcas(descripcion);
        this.props.fetchSellers({ descripcion }, "0", "0");
    };

    chargeFilterOptions = (options) => {
        this.setState({ datosExcelFormateados: null, filterOptions: options });
    };

    cargarTipoPublicacionLista = () => {
        if (!this.state.listaTipoPublicacionCargada) {
            const params = this.props.userType.isCategory || this.props.userType.isAdminMod
                ? { params: { "CantidadPagina": 100 } }
                : this.props.idSeller;
            this.props.fetchTiposPublicacionAdm(params);
            this.setState({ listaTipoPublicacionCargada: true });
        }
    };

    requestParaExportar = async (request) => {
        this.setState({ loadingExport: true, hideSpinner: false });

        try {
            const req = await fetchExportarPublicacionesApi(request);
            const cantidadPublicaciones = Number(req?.cantidadPublicaciones ?? 0);

            if (req?.excel && cantidadPublicaciones > 0) {
                this.setState({
                    cantidadPublicaciones,
                    hideSpinner: true,
                    excelBase64: req.excel
                });
            } else {
                toast.warn('No se encontraron publicaciones para exportar');
                this.setState({
                    hideSpinner: true,
                    cantidadPublicaciones: 0,
                    excelBase64: null
                });
            }
        } catch (err) {
            const data = normalizeErrorPayload(err?.response?.data);
            const errors = Array.isArray(data?.errors) ? data.errors : [];
            const errores = Array.isArray(data?.errores) ? data.errores : [];
            const messages = errors
                .map((error) => {
                    if (typeof error === 'string') return error;
                    return error?.errorMesage ?? error?.ErrorMesage ?? error?.message ?? error?.Message ?? '';
                })
                .filter(Boolean);

            const fallbackMessages = errores
                .map((error) => {
                    if (typeof error === 'string') return error;
                    return error?.item2 ?? error?.Item2 ?? error?.errorMesage ?? error?.ErrorMesage ?? '';
                })
                .filter(Boolean);

            const toastMessages = messages.length ? messages : fallbackMessages;
            if (toastMessages.length) {
                toastMessages.forEach((message) => toast.error(message));
            } else {
                toast.error('No se pudo preparar los datos para exportar');
            }

            this.setState({ hideSpinner: true, cantidadPublicaciones: 0, excelBase64: null });
        } finally {
            this.setState({ loadingExport: false });
        };
    };

    descargarArchivoExcel = (base64Data, nombreArchivo) => {
        const byteCharacters = atob(base64Data);
        const byteNumbers = Array.from(byteCharacters).map(c => c.codePointAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = nombreArchivo;
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    render() {
        return (
            <section className="container exportables-page" role="search">
                <div className="row mb-3 mb-md-4 align-items-center py-3 px-2 rounded admin-page-heading" style={{ background: 'linear-gradient(to right, #f8f9fa 0%, #fff 100%)', borderLeft: '4px solid var(--rojo-megatone, #c00)' }}>
                    <div className="col-12 col-md-7">
                        <h4 className="mb-0 text-themecolor color-rojo-megatone fw-bold">Exportables - Publicaciones</h4>
                        <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">
                            Descarga masiva de publicaciones con filtros de búsqueda.
                        </p>
                    </div>
                    <div className="col-12 col-md-5 mt-2 mt-md-0">
                        <div className="row justify-content-md-end align-items-center">
                            <div className="col-auto">
                                <div className="row justify-content-center">
                                    <div className="col-auto button-group text-right d-block">
                                        {!this.state.hideSpinner && (
                                            <div className="d-flex align-items-center gap-2">
                                                <MiniSpinner />
                                                <span className="small text-muted">Buscando...</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-12 col-md-auto button-group text-right">
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-green"
                                            onClick={() => {
                                                if (this.state.excelBase64) {
                                                    this.descargarArchivoExcel(this.state.excelBase64, `Publicaciones.xlsx`);
                                                    toast.success("Descarga iniciada. El archivo de publicaciones se esta preparando.");
                                                } else {
                                                    toast.warn("No hay datos para descargar");
                                                }
                                            }}
                                            disabled={!this.state.hideSpinner || this.state.cantidadPublicaciones === 0}
                                        >
                                            Descargar {this.state.cantidadPublicaciones || 0} publicaciones
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="exportables-filter-shell">
                    <PublicacionesFilter
                        filtro={this.props.emptyFiltro.publicaciones === false ? this.props.filtroPublicacion : null}
                        setInitialPage={() => {}}
                        chargeFilterOptions={this.chargeFilterOptions}
                        allowSearchBySeller={this.props.userType.isCategory || this.props.userType.isAdminMod}
                        hideIdPublicacion={true}
                        clearFilterOnUnmount={true}
                        persistFilterInRedux={false}
                        requestParaExportar={this.requestParaExportar}
                        onClearCantidad={() => this.setState({ cantidadPublicaciones: 0, excelBase64: null })}
                        shouldFetchOnClear={false}
                        loadingExport={this.state.loadingExport}
                    />
                </div>
                {this.props.loadingPublicaciones && <BigSpinner message="Cargando publicaciones para exportar..." />}
            </section>
        );
    }
}
ExportarPublicaciones.propTypes = {
    // Redux props
    idSeller: PropTypes.number,
    publicaciones: PropTypes.shape({
        cantidadTotal: PropTypes.number,

    }),
    userType: PropTypes.shape({
        isAdminMod: PropTypes.bool,
        isCategory: PropTypes.bool,
    }),
    filtroPublicacion: PropTypes.shape({
        idSeller: PropTypes.string,
        fechaPubDesde: PropTypes.string,
        fechaPubHasta: PropTypes.string,
        categoria: PropTypes.string,
        marca: PropTypes.string,
        estado: PropTypes.string,
        skuSeller: PropTypes.string,
        skuMarket: PropTypes.string,
        sinStock: PropTypes.bool,
    }),
    emptyFiltro: PropTypes.shape({
        publicaciones: PropTypes.bool,
    }),
    loadingPublicaciones: PropTypes.bool,
    // Actions props
    fetchVariaciones: PropTypes.func,
    fetchCategorias: PropTypes.func,
    fetchMarcas: PropTypes.func,
    fetchSellers: PropTypes.func,
    setFiltroPublicacion: PropTypes.func,
    fetchTiposPublicacionAdm: PropTypes.func,
}

const mapStateToProps = state => ({
    userType: state.general.userType,
    idSeller: state.general.idSeller,
    publicaciones: state.publicaciones.publicaciones,
    filtroPublicacion: state.publicaciones.filtroPublicaciones,
    cantidadTotal: state.publicaciones.publicaciones.cantidadTotal,
    loadingPublicaciones: state.publicaciones.loadingPublicaciones,
    emptyFiltro: state.general.limpiar
});

export default connect(mapStateToProps, {
    setFiltroPublicacion,
    fetchTiposPublicacionAdm,
    fetchPublicaciones,
    fetchCategorias,
    fetchVariaciones,
    fetchMarcas,
    fetchSellers
})(ExportarPublicaciones);